import "./RehearsalRoom.css";

import * as React from "react";

export default class RehearsalRoom extends React.Component {

    public render() {

        return (
            <div className="RehearsalRoom">
                Folgt bald!
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/RehearsalRoom.tsx